<template>
  <div class="box">
    <div class="calendarBox">
      <!-- 顶部插槽 -->
      <slot name="header"></slot>

      <!-- 顶部选择日期 -->
      <div class="navBox">
        <div class="enlargeBox">
          <img class="arrow" src="./static/arrow.png" mode="widthFix" @click="quickSelect('up')" />
        </div>
        <el-date-picker v-model="value1" type="month" placeholder="选择月" value-format="yyyy-MM" clear-icon
          @change="bindDateChange">
        </el-date-picker>
        <!-- <picker mode="date" :value="`${nowYear}-${nowMonth}`" fields="month">
          <div class="date">{{nowYear}}年{{nowMonth}}月</div>
        </picker> -->
        <div class="enlargeBox">
          <img class="arrow rightArrow" src="./static/arrow.png" mode="widthFix" @click="quickSelect('down')" />
        </div>
        <div class="getToday" @click="getToday">
          返回今天
        </div>
      </div>

      <!-- week -->
      <div class="weekBox">
        <div class="item" :style="{'color': item === '日' || item === '六' ? '#D6D6D6' : '#D6D6D6', }"
          v-for="(item, index) of weekList" :key="index">{{item}}</div>
      </div>

      <!-- list -->
      <div class="list">
        <div class="day blur" v-for="(item, index) of upMonthDayList" :key="index.day">
          <div>{{item.day}}</div>
          <div class="lunarCalendar" v-if="isLunarCalendar">{{item.lunarCalendar}}</div>
        </div>
        <!-- &&getYear = nowYear&&getMonth = nowMonth -->
        <div class="day" :class="{toDay: getDay == item.day && getYear == nowYear && getMonth == nowMonth}"
          :style="itemDayStyle + (nowDay != item.day ? dayStyle : toDayStyle)" v-for="(item, index) of nowMonthDayList"
          :key="index" @click="dayChange(item)">
          <div class="number" :class="'number'+ExamType">{{item.day}}</div>
          <div class="lunarCalendar" v-if="isLunarCalendar">{{item.lunarCalendar}}</div>
        </div>
        <div class="day blur" v-for="(item, index) of downMonthDayList" :key="index.day">
          <div>{{item.day}}</div>
          <div class="lunarCalendar" v-if="isLunarCalendar">{{item.lunarCalendar}}</div>
        </div>
      </div>

      <!-- 尾部插槽 -->
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import getDateFun from './date.js'
  import lunarCalendar from './lunar-alendar.js'
  export default {
    name: "xdd-calendar",
    props: {
      // 每周从星期几开始 默认周日
      weekBegin: {
        type: Number | String,
        default: function() {
          return 7
        }
      },
      // 是否开启农历
      isLunarCalendar: {
        type: Boolean,
        default: function() {
          return true
        }
      },

      // 圆角
      radius: {
        type: Number | String,
        default: function() {
          return 50
        }
      },
      // 页表阴影颜色
      pageBgColor: {
        type: String,
        default: function() {
          return `rgba(242, 138, 95, .8)`
        }
      },
      // 自定义样式 每一天
      itemDayStyle: {
        type: String,
        default: function() {
          return ''
        }
      },
      // 自定义样式 除去今天
      dayStyle: {
        type: String,
        default: function() {
          return ''
        }
      },
      // 自定义样式 今天
      toDayStyle: {
        type: String,
        default: function() {
          return ''
        }
      },
      ExamType: {
        type: Number,
        default: function() {
          return 3409
        }
      },
    },
    data() {
      return {
        value1: "",
        getYear: "", //选中年
        getMonth: "", //选中月
        getDay: "", //选中日
        nowYear: '', // 当前年
        nowMonth: '', // 当前月
        nowDay: '', // 当前日
        monthDays: '', // 当前月多少天
        beginMonthWeek: '', // 这个月开始时间是星期几

        weekList: [`日`, `一`, `二`, `三`, `四`, `五`, `六`],

        upMonthDayList: [], // 上个月剩下的日期数据
        nowMonthDayList: [], // 这个月的日期数组
        downMonthDayList: [], // 下个月剩下的日期数据
      };
    },
    created() {
      this.weekBegin == 6 ? this.weekList = [`六`, `日`, `一`, `二`, `三`, `四`, `五`] : ''
      this.bindDateChange()
    },
    methods: {
      getToday(){
        this.bindDateChange()
      },
      // 上下月
      quickSelect(type) {
        let [year, month, e] = ['', '', {}]
        if (type === 'up') {
          [year, month] = this.nowMonth === 1 ? [this.nowYear - 1, 12] : [this.nowYear, this.nowMonth - 1]
        } else if (type === 'down') {
          [year, month] = this.nowMonth === 12 ? [this.nowYear + 1, 1] : [this.nowYear, this.nowMonth + 1]
        }
        e = `${year}-${month}`;
        this.bindDateChange(e)
      },

      // 选择日期
      bindDateChange(e) {
        this.nowYear = e ? e.split('-')[0] - 0 : getDateFun.getFullYear()
        this.nowMonth = e ? e.split('-')[1] - 0 : getDateFun.getMonth()
        this.value1 = `${this.nowYear}-${this.nowMonth}`;
        // 初始加载触发选中当天
        if (!e) {
          this.getYear = getDateFun.getFullYear(); //选中年
          this.getMonth = getDateFun.getMonth(); //选中月
          this.getDay = getDateFun.getDate(); //选中日
          console.log(this.getYear, this.getMonth, this.getDay, "选中日期")
          const peasant = this.isLunarCalendar ? lunarCalendar.solar2lunar(this.getYear, this.getMonth, this.getDay) :{}
          const date = {
            year: this.nowYear,
            month: this.nowMonth,
            day: this.getDay,
            week: getDateFun.getWeekDay({
              year: this.nowYear,
              month: this.nowMonth,
              day: this.getDay
            }),
            IYearCn: peasant.lYear || '',
            IMonthCn: peasant.IMonthCn || '',
            IDayCn: peasant.IDayCn || ''
          }
          this.$emit('change', date)
        }
        this.nowDay = getDateFun.getDate()
        this.monthDays = getDateFun.getDays({
          year: this.nowYear,
          month: this.nowMonth
        })
        this.beginMonthWeek = getDateFun.getMonthWeekBegin({
          year: this.nowYear,
          month: this.nowMonth
        })
        // 选择日期事件
        this.$emit('selectDate', {
          year: this.nowYear,
          month: this.nowMonth,
          day: this.nowDay
        })

        // 上个月的数据
        let upMonthDay = getDateFun.getUpDays({
          year: this.nowYear,
          month: this.nowMonth
        }) // 上个月的天数
        this.upMonthDayList = [] // 上个月数据置空
        let upDay = 0
        switch (this.weekBegin) {
          case 7 | '7':
            upDay = this.beginMonthWeek % 7
            break
          case 6 | '6':
            upDay = (this.beginMonthWeek % 7 + 1) % 7
            break
        }
        const [upYear, upMonth] = this.nowMonth === 1 ? [this.nowYear - 1, 12] : [this.nowYear, this.nowMonth - 1]
        for (let i = 0; i < upDay; i++) {
          const peasant = lunarCalendar.solar2lunar(upYear, upMonth, upMonthDay - i)
          this.upMonthDayList.unshift({
            day: upMonthDay - i,
            week: getDateFun.getWeekDay({
              year: upYear,
              month: upMonth,
              day: upMonthDay - i
            }),
            lunarCalendar: peasant.IDayCn === '初一' ? peasant.IMonthCn : peasant.IDayCn
          })
        }

        // 当前月的数据
        this.nowMonthDayList = []
        for (let i = 1; i <= this.monthDays; i++) {
          const peasant = lunarCalendar.solar2lunar(this.nowYear, this.nowMonth, i)
          this.nowMonthDayList.push({
            day: i,
            week: getDateFun.getWeekDay({
              year: this.nowYear,
              month: this.nowMonth,
              day: i
            }),
            lunarCalendar: peasant.IDayCn === '初一' ? peasant.IMonthCn : peasant.IDayCn
          })
        }

        // 下个月的数据
        let downMonthDay = getDateFun.getDownDays({
          year: this.nowYear,
          month: this.nowMonth
        }) // 下个月的天数
        this.downMonthDayList = [] // 上个月数据置空
        let downDay = (7 - (upDay + this.monthDays) % 7) % 7
        const [downYear, downMonth] = this.nowMonth === 12 ? [this.nowYear + 1, 1] : [this.nowYear, this.nowMonth + 1]
        for (let i = 0; i < downDay; i++) {
          const peasant = lunarCalendar.solar2lunar(downYear, downMonth, i + 1)
          this.downMonthDayList.push({
            day: i + 1,
            week: getDateFun.getWeekDay({
              year: downYear,
              month: downMonth,
              day: i + 1
            }),
            lunarCalendar: peasant.IDayCn === '初一' ? peasant.IMonthCn : peasant.IDayCn
          })
        }
      },

      // 点击事件
      dayChange(e) {
        console.log(e, "eeee")
        const peasant = this.isLunarCalendar ? lunarCalendar.solar2lunar(this.nowYear, this.nowMonth, e.day) : {}
        const date = {
          year: this.nowYear,
          month: this.nowMonth,
          day: e.day,
          week: e.week,
          IYearCn: peasant.lYear || '',
          IMonthCn: peasant.IMonthCn || '',
          IDayCn: peasant.IDayCn || ''
        }
        this.getYear = this.nowYear; //选中年
        this.getMonth = this.nowMonth; //选中月
        this.getDay = e.day; //选中日
        this.$emit('change', date)
      }
    }
  }
</script>

<style>
  .box {
    position: relative;
  }

  .calendarBox {
    background-color: #FFF;
    border-radius: 20px;
    font-size: 14px;
    color: #333;
  }

  .navBox {
    width: 280px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 5px;
  }

  .navBox .enlargeBox {
    width: 28px;
    height: 28px;
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #D8D8D8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navBox .enlargeBox .arrow {
    width: 14px;
    height: 14px;
    opacity: 0.5;
    cursor: pointer;
  }

  .navBox .enlargeBox .rightArrow {
    transform: rotate(180deg);
  }
  .navBox .el-date-editor{
    width: 100px !important;
    height: 30px;
  }
  .navBox .el-date-editor input{
    width: 100px;
    height: 30px;
    padding: 0 15px;
    line-height: initial;
    text-align: center;
  }
  .navBox .el-date-editor .el-input__prefix{
    display: none;
  }

  .getToday{
    width: 86px;
    height: 28px;
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #D8D8D8;
    color: rgba(0,0,0,0.5);
    text-align: center;
    line-height: 28px;
    cursor: pointer;
  }

  .weekBox {
    padding: 5px 0;
    display: flex;
    align-items: center;
    text-align: center;

  }

  .weekBox .item {
    width: calc(100% / 7);
  }

  .page {
    width: calc(100% - 60px);
    height: 100px;
    position: relative;
    top: -70px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: -1;
    background-color: #FFF;
  }

  .pageTwo {
    width: calc(100% - 120px);
    top: -150px;
    z-index: -2;
  }

  .list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .list .day {
    width: calc(100% / 7);
    height: 34px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    cursor: pointer;
    font-size: 14px;
  }

  .list .day .lunarCalendar {
    display: none;
    width: 100%;
    font-size: 14px;
    margin-top: -20px;
  }

  .list .day .number {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    line-height: 30px;
  }

  .list .blur {
    opacity: 0.3;
  }

  .list .toDay .number {
    background: rgba(255, 6, 89, 1);
    box-shadow: 0px 6px 20px 0px rgba(255, 6, 89, 0.4);
    color: #FFF;
  }
  .list .toDay .number3409{
    background: rgba(51, 124, 255, 1);
    box-shadow: 0px 6px 20px 0px rgba(51, 124, 255, 0.40);
  }
  .list .toDay .number3411{
    background: rgba(21, 206, 178, 1);
    box-shadow: 0px 6px 20px 0px rgba(21, 206, 178, 0.40);
  }
  .list .toDay .number3412{
    background: rgba(135, 141, 255, 1);
    box-shadow: 0px 6px 20px 0px rgba(135, 141, 255, 0.40);
  }
</style>



// WEBPACK FOOTER //
// src/components/xdd-calendar/xdd-calendar.vue